import React, { useState } from "react";
import { globalVars } from "../../global/GlobalVars.js";
import * as user from "../../utils/user.js";
import * as navigation from "../../utils/navigation.js";
import * as language from "../../utils/language.js";

const EditUser = (props) => {
  const [username, setUsername] = useState("");
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confPassword, setConfPassword] = useState("");
  const [feedbackMessage, setFeedbackMessage] = useState("");

  const handleSubmit = (e) => {
    //========================================================================
    // Passwort ändern
    user.changePassword(
      e,
      username,
      oldPassword,
      newPassword,
      confPassword,
      setFeedbackMessage
    );
    setUsername("");
    setOldPassword("");
    setNewPassword("");
    setConfPassword("");
  };

  if (globalVars.auth.changeUsers) {
    return (
      <div
        style={{
          ...props.style,
          backgroundColor: "lightgray",
        }}
      >
        <form
          onSubmit={handleSubmit}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "80%",
            margin: "0 auto",
          }}
        >
          <div
            style={{
              color: "black",
              fontSize: "100%",
              padding: "10px",
              width: "100%",
              display: "flex",
              justifyContent: "center",
            }}
          >
            {language.displayText(["Benutzer bearbeiten"])}
          </div>
          <input
            type="text"
            list="usernames"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="Username"
            style={{
              margin: "10px 0",
              padding: "10px",
              width: "100%",
            }}
          />
          <datalist id="usernames">
            {globalVars.users.map((user) => (
              <option key={user} value={user} />
            ))}
          </datalist>
          <input
            type="password"
            value={oldPassword}
            onChange={(e) => setOldPassword(e.target.value)}
            placeholder="Old Password"
            style={{
              margin: "10px 0",
              padding: "10px",
              width: "100%",
            }}
          />
          <input
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            placeholder="New Password"
            style={{
              margin: "10px 0",
              padding: "10px",
              width: "100%",
            }}
          />
          <input
            type="password"
            value={confPassword}
            onChange={(e) => setConfPassword(e.target.value)}
            placeholder="Confirm new Password"
            style={{
              margin: "10px 0",
              padding: "10px",
              width: "100%",
            }}
          />
          <button
            type="submit"
            style={{
              margin: "10px 0",
              padding: "10px",
              width: "100%",
            }}
          >
            Change
          </button>
          {feedbackMessage && (
            <p
              style={{
                textAlign: "center",
                color: feedbackMessage.includes("Error") ? "red" : "green",
              }}
            >
              {feedbackMessage}
            </p>
          )}
        </form>
      </div>
    );
  } else {
    return (
      <div
        style={{
          ...props.style,
          backgroundColor: "lightgray",
        }}
      ></div>
    );
  }
};

export default EditUser;
